// The below are disabled, but should probably be looked into at some point
/* eslint no-useless-escape: off */
/* eslint no-control-regex: off */

import { Injectable } from '@angular/core';

type EmailFirstLastNameParsed = {
    email: string | null;
    firstName: string | null;
    lastName: string | null;
};

@Injectable({ providedIn: 'root' })
export class StringUtilities {
    // This expression was picked to match server and taken from
    // http://referencesource.microsoft.com/#System.ComponentModel.DataAnnotations/DataAnnotations/EmailAddressAttribute.cs, 05520243d25cf146
    static readonly EMAIL_REGEXP =
        /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
    static readonly PASSWORD_REGEXP =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#~`%&:;,/=+\$\^\*\\\|\$\^\*\?\.\{\}\[\]])(?=.{8,})/;
    // allows for query parameters
    readonly urlRegExRequiresHttpOrHttps =
        /(https?:\/\/)[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?((\?|\&)([^=]+)\=([^&]+))?/;
    readonly simpleUrlFragmentRegEx = /^[a-zA-Z0-9\.\-_]+$/;
    static readonly phoneNumberRegex =
        /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    static readonly phoneNumberReplacementString = '($1) $2-$3';
    static readonly HTML_TAG_REGEXP = /<\/?[^>]+(>|$)/g;

    stripStart(rawString: string, prefixToKill: string) {
        return rawString.startsWith(prefixToKill)
            ? rawString.slice(1)
            : rawString;
    }

    formatString(format: string, ...params: any[]) {
        return format.replace(/{(\d+)}/g, (match, num) =>
            // TODO: !== ?
            typeof params[num] !== 'undefined' ? params[num] : match
        );
    }

    isAnEmailString(possibleEmailString: string): boolean {
        return StringUtilities.EMAIL_REGEXP.test(possibleEmailString);
    }

    static rawEmailValidation(v: string) {
        return StringUtilities.EMAIL_REGEXP.test(v ? v.toLowerCase() : v);
    }

    isUrlString(possibleUrlString: string): boolean {
        return this.simpleUrlFragmentRegEx.test(possibleUrlString);
    }

    parseEmailFirstNameLastNameFromString(
        inputString: string
    ): EmailFirstLastNameParsed {
        const parsedFields: EmailFirstLastNameParsed = {
            email: null,
            firstName: null,
            lastName: null
        };

        if (inputString) {
            const trimmedText = inputString.trim();
            if (this.isAnEmailString(trimmedText)) {
                parsedFields.email = trimmedText;
            } else {
                const firstSpace = trimmedText.indexOf(' ');
                if (firstSpace > 0) {
                    parsedFields.firstName = trimmedText
                        .substring(0, firstSpace)
                        .trim();
                    parsedFields.lastName = trimmedText
                        .substring(firstSpace)
                        .trim();
                } else {
                    parsedFields.firstName = trimmedText;
                }
            }
        }

        return parsedFields;
    }

    displayName(
        firstName: string,
        lastName: string,
        middleName?: string
    ): string {
        return middleName
            ? firstName + ' ' + middleName + ' ' + lastName
            : firstName + ' ' + lastName;
    }

    replaceFNameToken(content: string, firstName: string): string {
        const fnameToken = /\[fname\]/gi;
        return content.replace(fnameToken, firstName);
    }

    uncapitalize(str: string): string {
        if (str) {
            return str[0].toLowerCase() + str.slice(1);
        } else {
            return str;
        }
    }

    removeHtmlTags(input: string): string {
        return input.replace(StringUtilities.HTML_TAG_REGEXP, '');
    }
}
